import { toast } from "react-toastify";
import { fetchAddUsageEventTypeSuccess, fetchAddUsageEventTypeFailure } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { ADD_USAGE_EVENT_TYPE_API } from "../../constants/constants";
import { setSuccessMessage } from "../../toastMessage/action";

export const addUsageEventType = (jsonObj, setLoading, triggerRefresh) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${ADD_USAGE_EVENT_TYPE_API}`, 'POST', jsonObj).then((response) => {
        if (!response.error) {
            setLoading(false)
            triggerRefresh()
            dispatch(fetchAddUsageEventTypeSuccess(response))
            dispatch(setSuccessMessage(true))
           
        }
        if (response.error) {
            dispatch(fetchAddUsageEventTypeFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
    }).catch((errorResp) => { })
}